
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/eSwarna-digital-gold/general",
      function () {
        return require("private-next-pages/help/eSwarna-digital-gold/general.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/eSwarna-digital-gold/general"])
      });
    }
  